import { useQuery } from "@tanstack/react-query";

import { notificationsApi } from "../lib/api";

export const notificationSummaryQueryKey = ["notifications", "summary"] as const;

export const useNotificationSummary = () =>
  useQuery({
    queryKey: notificationSummaryQueryKey,
    queryFn: () => notificationsApi.summary(),
  });
